import React from 'react';

import styled from 'styled-components';

import {
    useContactsSelector,
    useContactsSelectorDispatch,
} from '@components/ContactsSelector/Common/ContactsSelectorContext';
import useSelectedFilterDisplay from '@components/ContactsSelector/Common/UseSelectedFilterDisplay';
import NwIcon from '@components/Gui/NwIcon';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const Wrapper = styled.div`
    display: flex;
    font-size: 0.8em;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;

    .texts-wrapper {
        flex: 1 1 0;
        .label {
            font-weight: bold;
        }
        .value {
            padding-left: 1rem;
            span {
                display: block;
            }
        }
    }
    .remove-button-wrapper {
        font-size: 1rem;
    }
`;

const ContactsSelectedFilterItem = ({ filter }) => {
    const { selection } = useContactsSelector();
    const cs_dispatch = useContactsSelectorDispatch();
    const { filters } = selection;

    const getFilterDisplay = useSelectedFilterDisplay();

    const removeFilterFromWorkingFilters = () => {
        let newWorkingFilters = filters.active.filter((f) => f.name !== filter.name);

        if (filter.name === 'AddedSince') {
            const addedUntil = filters.active.find((f) => f.name === 'AddedUntil');
            if (addedUntil) {
                newWorkingFilters = newWorkingFilters.filter((f) => f.name !== 'AddedUntil');
            }
        }
        if (filter.name === 'AddedUntil') {
            const addedSince = filters.active.find((f) => f.name === 'AddedSince');
            if (addedSince) {
                newWorkingFilters = newWorkingFilters.filter((f) => f.name !== 'AddedSince');
            }
        }

        cs_dispatch({ type: 'ChangeFilters', filters: newWorkingFilters });
        cs_dispatch({ type: 'ApplyWorkingFilters' });
    };

    const display = getFilterDisplay(filter);

    if (!display) {
        return <></>;
    }

    return (
        <Wrapper>
            <div className="texts-wrapper">
                <div className="label">{display.label}</div>
                {display.values.length > 0 && (
                    <div className="value">
                        {display.values.map((value, index) => (
                            <span key={index}>{value}</span>
                        ))}
                    </div>
                )}
            </div>
            <div className="remove-button-wrapper">
                <NwIcon pointer icon={byPrefixAndName.fasl['times']} onClick={removeFilterFromWorkingFilters} />
            </div>
        </Wrapper>
    );
};

export default ContactsSelectedFilterItem;
